import { AccountsContainer } from '../../../containers/AccountsContainer'

export const Accounts = (): JSX.Element => {
  return <AccountsContainer />
}
